import React from "react";
import Header from "../components/header";
import DividerBottom from "../components/divider-bottom";
import Footer from "../components/footer";

import CSB from "../assets/images/csb.png";
import CSS from "../assets/images/css.png";
import CSG from "../assets/images/csg.png";

function Badges() {
    return (
        <>
            <Header />
                <main>
                    <section id="badges">
                        <h1>Chief Scout Awards</h1>
                        <div className="badges-container">
                            <div className="badge">
                                <h2>Chief Scout Bronze Award</h2>
                                <img src={CSB} alt="Chief Scout Bronze Award"></img>
                                <p>The Chief Scout Bronze Award is the highest award a Beaver Scout can earn. It requires a Beaver to complete all the challenge awards and any 4 activity badges.</p>
                            </div>
                            <div className="badge">
                                <h2>Chief Scout Silver Award</h2>
                                <img src={CSS} alt="Chief Scout Silver Award"></img>
                                <p>The  Chief Scout Silver Award is the highest award a Cub Scout can achieve. It involves earning all the challenge badges within Cubs and at least 6 activity badges.</p>
                            </div>
                            <div className="badge">
                                <h2>Chief Scout Gold Award</h2>
                                <img src={CSG} alt="Chief Scout Gold Award"></img>
                                <p>The  Chief Scout Gold Award is the pinnacle for Scouts. It requires earning all the challenge awards and a minimum of 6 activity badges.</p>
                            </div>
                        </div>
                    </section>
                <DividerBottom />
                </main>
                <Footer />
        </>
    );
}

export default Badges;
